import { CheckboxCard } from "@/src/components/cards";
import SearchKeyHighliter from "@/src/components/seachkeyHighlighter";
import {
  Appointment,
  CardType,
  Exam,
  ExamGroup,
  Patient,
  Service,
  SimpleExam,
} from "@/src/data/allTypes";
import { getItemId, getUserShortName, uid } from "@/src/utils/utils";
import moment from "moment";
import { openExamActionsDialog } from "../exams/examActionsDialog";
import { ExamDemandButton } from "../exams/examDemandButton";
import ExamSamplesButton from "../exams/examSamplesButton";
import {
  openExamEditDrawer,
  openExamsVisualisationDrawer,
} from "../exams/openExamVisualisationDrawer";
import { openConfirmDialog } from "@/src/components/dialogs";
import apiFetch from "@/src/utils/apiFetch";

export function ExamGroupCard({
  group,
  exams,
  patient,
  type,
  searchKey,
  allExams,
  allAppointments,
  allServices,
  onChange,
}: {
  group: ExamGroup;
  exams: SimpleExam[];
  patient: Patient;
  type?: CardType;
  searchKey?: string;
  allExams: (SimpleExam | Exam)[];
  allAppointments: Appointment[];
  allServices: Service[];
  onChange: () => void;
}) {
  return (
    <CheckboxCard
      status={
        exams?.find((exam) => exam.status != "finished") ? "inactive" : "active"
      }
      color={type || "orange"}
      className={`c1 gap10 ${
        exams?.find((exam) => exam.status != "finished") ? "" : ""
      }`}
      title={<div className="bold">{group?.referencesGroup?.name || "-"}</div>}
      subTitle={getUserShortName(exams?.[0]?.creator)}
      onDelete={async () => {
        await openConfirmDialog({
          title: "Supprimer le groupe d'examens",
          content: "Voulez-vous vraiment supprimer le groupe d'examens ?",
          onConfirm: async () => {
            for (const exam of exams) {
              await apiFetch("exams", "deleteOne", {
                id: exam.id,
              });
            }
            onChange();
          },
        });
      }}
    >
      <div className="c1 gap10">
        <div className="gray">
          {moment(exams?.[0]?._date).format("LL HH:mm")}
        </div>
        <div className="c1 gap10">
          {exams.map((exam) => {
            const index = allExams.findIndex(
              (existingExam) => getItemId(existingExam) == getItemId(exam)
            );
            return (
              <CheckboxCard
                key={uid()}
                color={type || "orange"}
                status={exam.status == "finished" ? "active" : "inactive"}
                title={
                  <SearchKeyHighliter searchKey={searchKey}>
                    {exam.reference?.name}
                  </SearchKeyHighliter>
                }
                className="empty"
                onClick={async (e) => {
                  e.stopPropagation();
                  if (exam.status == "finished")
                    return await openExamsVisualisationDrawer({
                      exams: allExams || [],
                      index,
                      onEdit: async () => {
                        onChange();
                      },
                    });

                  await openExamEditDrawer({
                    examId: exam.id,
                    onConfirm: async (newExam) => {
                      onChange();
                    },
                  });
                }}
                onMore={async () => {
                  await openExamActionsDialog({
                    allAppointments: allAppointments || [],
                    exams: allExams || [],
                    index,
                    patient,
                    services: allServices || [],
                    onChange: async () => {
                      onChange();
                    },
                  });
                }}
              >
                <div className="c1 gap5" style={{ maxWidth: "400px" }}>
                  <ExamDemandButton
                    patient={patient}
                    exam={exam}
                    isHospitalized={true}
                    allAppointments={allAppointments || []}
                    allServices={allServices || []}
                    onChange={async () => {
                      onChange();
                    }}
                  ></ExamDemandButton>
                  <ExamSamplesButton
                    patient={patient}
                    exam={exam}
                    onChange={async () => {
                      onChange();
                    }}
                  ></ExamSamplesButton>
                </div>
              </CheckboxCard>
            );
          })}
        </div>
      </div>
    </CheckboxCard>
  );
}
